<wiz-hgroup #actionContainer width="100%" height="100%" verticalAlign="center" style="padding: 3px">

  <wiz-icon (click)="doDelete()">delete</wiz-icon >
  <wiz-icon  (click)="doEdit()">icon-edit</wiz-icon>
  <wiz-hgroup width="100%">
    <wiz-label [wizLabel]="fullLabel" width="100%"></wiz-label>
  </wiz-hgroup>
</wiz-hgroup>
